import * as React from 'react';
import Modal, { ModalSize } from './modal';
import { NotesModalBody } from './NotesModalBody';
import { SessionNote, SubjectNote, TestNote } from 'webportalclient';

export interface NotesModalProps {
    header: string;
    isVisible: boolean;
    isAddingNote: boolean;
    disabled: boolean;
    notes: SessionNote[] | SubjectNote[] | TestNote[];
    onAdd: (annotation: string) => void;
    onCloseModal: () => void;
    changeButtonText?: string;
    notificationBanner?: JSX.Element;
}

export const NotesModal = (props: NotesModalProps) => {
    if (props.isVisible) {

        return (
            <Modal show={true} header={props.header} size={ModalSize.Large} closeModalHandler={() => props.onCloseModal()} automationId="NotesModal">
                {props.notificationBanner}
                <NotesModalBody
                    notes={props.notes}
                    isAddingNote={props.isAddingNote}
                    disabled={props.disabled}
                    onAdd={props.onAdd}
                    onCloseModal={props.onCloseModal}
                    changeButtonText={props.changeButtonText}
                />
            </Modal>
        );
    } else {
        return null;
    }
}
